var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('on-click-outside',{attrs:{"is-active":_vm.isOpen,"execute":_vm.close,"exclude":['.dropdown-menu']}},[_c('div',{staticClass:"relative flex flex-col w-full m-auto"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }